var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('ImageViewer',_vm._g(_vm._b({attrs:{"on-close":_vm.handleHide,"url-list":_vm.urlList}},'ImageViewer',_vm.$attrs,false),_vm.$listeners)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }